/* Modulo Product Grid — quick-add + wishlist for a static product grid.
   Vanilla, lazy-init, no slider. Cart-add mirrors the featured-products pattern. */
(function () {
  'use strict';

  /* ── Cart notify ────────────────────────────────────────────────────
     Per Shopify's docs a theme's cart is recognised one of two ways:
     Dawn-style, via an element whose prototype has getSectionsToRender(),
     or Horizon-style, via a cart-icon with renderCartBubble() and
     cart-items with updateQuantity() — which are driven by a `cart:update`
     event dispatched on `document`. This section never sent that event, so
     on Horizon and its forks the badge kept its render-time number until
     the shopper reloaded.

     itemCount comes from /cart.js, NOT from summing the add response.
     /cart/add.js returns only "the line items associated with the added
     items" and carries no item_count, so summing it reports how many were
     just added — a shopper holding 3 who adds 1 would have the badge
     REWRITTEN to 1. A null count still tells a component to re-render.

     NOTE: this section does not yet request the theme's cart sections on
     add, so on a DAWN-style theme the drawer it opens can still show
     page-load HTML. Wiring `sections`/`sections_url` here the way
     product-quickbuy does is tracked as follow-up work. */
  function notifyCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    if (window.Shopify && window.Shopify.PubSub) {
      try { window.Shopify.PubSub.publish('cart-update', {}); } catch (e) {}
    }
    function fire(count) {
      try {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { itemCount: count, source: 'modulo-product-grid' } }
        }));
      } catch (e) {}
    }
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(r + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (x) { return x.ok ? x.json() : null; })
      .then(function (c) { fire(c && typeof c.item_count === 'number' ? c.item_count : null); })
      .catch(function () { fire(null); });
  }

  if (typeof window === 'undefined') return;
  /* Load-once guard: the section emits one <script> per instance, so 2+ grids on a
     page would otherwise register the document listener twice and double-toggle wishlist. */
  if (window.__moduloPgLoaded) return;
  window.__moduloPgLoaded = true;

  /* ─── Wishlist (localStorage, no backend) ─── */
  function wishlistRead(key) {
    try { var raw = localStorage.getItem(key); return raw ? JSON.parse(raw) : []; }
    catch (e) { return []; }
  }
  function wishlistWrite(key, list) {
    try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
  }
  function wishlistKey(root) {
    return root.getAttribute('data-modulo-pg-wishlist-key') || 'modulo_wishlist';
  }
  function wishlistHydrate(root) {
    var key = wishlistKey(root);
    var saved = wishlistRead(key);
    if (!saved.length) return;
    var buttons = root.querySelectorAll('[data-modulo-pg-wishlist]');
    for (var i = 0; i < buttons.length; i++) {
      var h = buttons[i].getAttribute('data-product-handle');
      if (saved.indexOf(h) !== -1) {
        buttons[i].classList.add('is-active');
        buttons[i].setAttribute('aria-pressed', 'true');
      }
    }
  }
  function wishlistToggle(btn, root) {
    var key = wishlistKey(root);
    var h = btn.getAttribute('data-product-handle');
    var list = wishlistRead(key);
    var idx = list.indexOf(h);
    if (idx === -1) {
      list.push(h);
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
    } else {
      list.splice(idx, 1);
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
    }
    wishlistWrite(key, list);
    document.dispatchEvent(new CustomEvent('modulo:wishlist:changed', {
      detail: { handle: h, active: idx === -1, key: key }
    }));
  }
  document.addEventListener('modulo:wishlist:changed', function (e) {
    var d = e.detail;
    var selector = '[data-modulo-pg-wishlist][data-product-handle="' + d.handle + '"]';
    var buttons = document.querySelectorAll(selector);
    for (var i = 0; i < buttons.length; i++) {
      var section = buttons[i].closest('[data-modulo-pg-wishlist-key]');
      if (!section || section.getAttribute('data-modulo-pg-wishlist-key') !== d.key) continue;
      if (d.active) {
        buttons[i].classList.add('is-active');
        buttons[i].setAttribute('aria-pressed', 'true');
      } else {
        buttons[i].classList.remove('is-active');
        buttons[i].setAttribute('aria-pressed', 'false');
      }
    }
  });

  /* ─── Cart add ─── */
  function findCartDrawer() {
    return document.querySelector('cart-drawer, cart-drawer-component, [is="cart-drawer"], [data-cart-drawer]');
  }
  function openCartDrawer() {
    var drawer = findCartDrawer();
    if (!drawer) return;
    if (typeof drawer.open === 'function') drawer.open();
    else if (typeof drawer.show === 'function') drawer.show();
    else {
      var trigger = document.querySelector('[aria-controls*="cart"]');
      if (trigger) trigger.click();
    }
  }
  function quickAdd(button) {
    if (button.dataset.adding === '1') return;
    button.dataset.adding = '1';
    var variantId = button.getAttribute('data-variant-id');
    var labelEl = button.querySelector('.modulo-pg__qa-label');
    var originalLabel = labelEl ? labelEl.textContent : '';
    var addedLabel = button.getAttribute('data-added-label') || 'Added';

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      // X-Modulo-Internal opts out of the bundle block's in-flight fetch shim.
      // Without it a quick-add landing inside that window is answered with a
      // synthetic 200 {"items":[]} and takes the SUCCESS path on an add that
      // never happened.
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Modulo-Internal': 'product-grid' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart-add-failed');
      return r.json();
    }).then(function () {
      button.classList.add('is-added');
      if (labelEl) labelEl.textContent = addedLabel;
      setTimeout(function () {
        button.classList.remove('is-added');
        if (labelEl) labelEl.textContent = originalLabel;
      }, 1800);
      notifyCart();
      openCartDrawer();
    }).catch(function () {
      if (labelEl) {
        labelEl.textContent = 'Error';
        setTimeout(function () { labelEl.textContent = originalLabel; }, 1800);
      }
    }).finally(function () {
      button.dataset.adding = '0';
    });
  }

  /* ─── Init ─── */
  function initSection(root) {
    root.addEventListener('click', function (e) {
      var qaBtn = e.target.closest('[data-modulo-pg-quick-add]');
      if (qaBtn && qaBtn.tagName === 'BUTTON' && !qaBtn.disabled) {
        e.preventDefault();
        e.stopPropagation();
        quickAdd(qaBtn);
        return;
      }
      var wlBtn = e.target.closest('[data-modulo-pg-wishlist]');
      if (wlBtn) {
        e.preventDefault();
        e.stopPropagation();
        wishlistToggle(wlBtn, root);
        return;
      }
    });
    wishlistHydrate(root);
  }

  function bootstrap() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-pg]', initSection);
    } else {
      var sections = document.querySelectorAll('[data-modulo-pg]');
      for (var i = 0; i < sections.length; i++) initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
